import { lazy, Suspense } from 'react';
import { Route } from 'react-router-dom';

import { CountrySelector } from './components/PhoneField/CountrySelector';
import { WithdrawalRejectController } from './components/WithdrawalReject/WithdrawalRejectController';
import { ContentController } from './Content/ContentController';
import { CurrencySelector } from './CurrencySelectContainer/CurrencySelector/CurrencySelector';
import { NetworkSelector } from './CurrencySelectContainer/NetworkSelector/NetworkSelector';
import { BetShopsDeposit } from './Deposit/BetShops';
import { BetShopsWithdrawal } from './Withdrawal/BetShops/BetShopsWithdrawal';

const BonusSelectLazy = lazy(
  () => import(/* webpackChunkName: "bonus-select" */ './components/BonusInfo/BonusesSelect'),
);

const BonusDescriptionLazy = lazy(
  () =>
    import(
      /* webpackChunkName: "bonus-description" */ './components/BonusInfo/components/BonusDescription/BonusDescription'
    ),
);

export type RouteItem = { path: string; element: React.ReactElement };

export const modalRoutesMap: RouteItem[] = [
  {
    path: 'content',
    element: <ContentController />,
  },
  {
    path: 'reject-withdrawal',
    element: <WithdrawalRejectController />,
  },
  {
    path: 'betshop-deposit',
    element: <BetShopsDeposit />,
  },
  {
    path: 'betshop-withdrawal',
    element: <BetShopsWithdrawal />,
  },
  {
    path: 'select-country',
    element: <CountrySelector />,
  },
  {
    path: 'select-currency',
    element: <CurrencySelector />,
  },
  {
    path: 'select-network',
    element: <NetworkSelector />,
  },
  {
    path: 'select-bonus',
    element: <BonusSelectLazy />,
  },
  {
    path: 'bonus-description',
    element: <BonusDescriptionLazy />,
  },
];

export const modalRoutes = (prefix?: string) =>
  modalRoutesMap.map((r) => (
    <Route key={r.path} path={`${prefix || ''}${r.path}`} element={<Suspense fallback={null}>{r.element}</Suspense>} />
  ));
